<template>
  <div
    v-if="isVisible"
    class="warning"
  >
    <div class="warning__text">
      Utilizamos cookies essenciais para melhorar e personalizar sua experiência em nosso site. Ao continuar navegando, você concorda com a nossa <router-link :to="{name: 'legal.privacy'}">Política de Privacidade</router-link>.
    </div>

    <button
      @click="acceptTerms"
      class="warning__buttom"
    >
      Ok, entendi
    </button>
  </div>
</template>

<script>
  export default {
    data: () => ({
      hasAccepted: false,
      isRouteAllowed: false
    }),

    computed: {
      isVisible () {
        return !localStorage.getItem('accepted-cookie-terms') && !this.hasAccepted
      }
    },

    methods: {
      acceptTerms () {
        localStorage.setItem('accepted-cookie-terms', 1)
        this.hasAccepted = true
      }
    }
  }
</script>

<style scoped lang="scss">
  .warning {
    display: flex;
    align-items: center;
    z-index: 10;
    position: fixed;
    left: 5%;
    bottom: 10%;
    width: 600px;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 1px 1px 15px rgba(#000, .3);
    background: #fff;

    &__text {
      font-size: 15px;
      line-height: 1.4;
      padding-right: 15px;
    }

    &__buttom {
      flex-shrink: 0;
      background: #ff8800;
      color: #fff;
      font-weight: 700;
      font-size: 14px;
      padding: 7px 10px;
      border-radius: 5px;

      &:hover {
        border-color: transparent;
      }
    }

    @media (max-width: 650px) {
      & {
        flex-direction: column;
        bottom: 5%;
        left: 3%;
        width: 94%;

        &__text {
          padding-right: 0;
          padding-bottom: 10px;
        }
      }
    }
  }
</style>